import React, { useRef } from "react"

import { RadioButton } from "primereact/radiobutton"
import { FileUpload } from "primereact/fileupload"

import { AutoCompleteField, Button, CalendarField, DropDownField, TextInputField } from "../../../helpers"
import Tooltip from "../../../helpers/Tooltip"
import Menu from "../../../helpers/Menu"
import FileViewAndRemove from "../../../common/FileViewAndRemove"


const RequirementDetails = (props) => {
    const {  
        buyerReqId,
        requirement,
        orderTypes,
        handleOrderType,
        formErrors,
        companySearchMethod,
        companySuggestions,
        handleCompanyChange,
        isCompanyDataLoading,
        companies,
        branches,
        gstins,
        users,
        warehouses,
        pmBranches,
        handleBranchChange,
        handleGstinChange,
        handleUserChange,
        handlePMWarehouse,
        handlePMBranch,
        isBranchDataLoading,
        isGSTINSDataLoading,
        isUsersDataLoading,
        handleRoutedChange,
        handleReqTagChange,
        handleReqSource,
        handleTaxExemption,
        handleRequirementCreatedTime,
        handleSourceDocUpload,
        removeSourceDocument,
        uploadOptions,
        fileUploadDisableCond,
        handlProductsUploadFile,
        bussinessTypes,
        handleBussinessType,
        bgColorVMI,
        reqTags,
        PMCompanyConfig,
        companyWarehouses,
        handleClientReqNoChange
    } = props

    const uploadMenu = useRef(null)

    const lastMonthDate = new Date()
    lastMonthDate.setMonth(new Date().getMonth() - 1)
    const nextMonthDate = new Date()
    nextMonthDate.setMonth(new Date().getMonth() + 1)

    let company = requirement.companyId
    if (typeof (requirement.companyId) === "number") {
        company = companies?.find(eachCompany => eachCompany.companyId === requirement.companyId)
    }

    let updatedOrderTypes = [...orderTypes]
    if(!requirement.bussinessTypeId){
        updatedOrderTypes = []
    }

    let updatedWarehouses = [...warehouses]
    if(requirement.bussinessTypeId === 2 && (!requirement.branchId || !requirement.pmBranchId)){
        updatedWarehouses = []
    }
    // else if(requirement.bussinessTypeId === 2 && requirement.pmBranchId){
    //     const relatedBranches = pmBranches.filter(eachPMBranch => eachPMBranch.branchId === requirement.pmBranchId)
    //     let warehouseIds = relatedBranches.map(eachBranch => eachBranch.warehouseId)
    //     updatedWarehouses = warehouses.filter(eachWarehouse => warehouseIds.includes(eachWarehouse.warehouseId))
    // }
    
    let companyBuyerBranches = branches.filter(eachCompanyBranch => [1, 3].includes(eachCompanyBranch.branchType))
    console.log("branches", branches)

    return (
        <div className={`p-card pb-3 ${bgColorVMI}`}>
            <div className="grid flex-row">
                <div className='flex md:flex-column col-12 md:col-1 md:p-0 p-2 pb-0'>
                    <div className="flex flex-column pl-0 pr-2 ml-1">
                        <div><span className='text-xs'>Business Type</span><span className="required-mark">*</span></div>
                        <div className="flex flex-column ml-2 mt-2">
                            <div className="flex flex-row">
                                <RadioButton inputId={1} value={1} onChange={handleBussinessType} checked={requirement.bussinessTypeId === 1} disabled={buyerReqId}/>
                                <label htmlFor="yes" className="text-xs mb-2">Regular</label>
                            </div>
                            <div className="flex ml-5 md:ml-0">
                                <RadioButton inputId={2} value={2} onChange={handleBussinessType} checked={requirement.bussinessTypeId === 2} disabled={buyerReqId}/>
                                <label htmlFor="no" className="text-xs">VMI</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex md:flex-column col-12 md:col-1 md:p-0 px-2 py-0">
                    <div className="flex flex-column col-12 lg:mb-0">
                        <DropDownField name="orderType" options={updatedOrderTypes} value={requirement.orderTypeId} optionLabel="orderType" optionValue="orderTypeId" labelText="Order Type" onChange={handleOrderType} errorMessage={formErrors.orderTypeId} required disabled={buyerReqId}/>
                    </div>
                </div>
                <div className='flex flex-wrap col-12 md:col-10 md:p-0 px-2 pt-0'>
                    {/* <div className="flex flex-column col-12 md:col-2 lg:col-2 lg:mb-0 order-type-input">
                        <DropDownField name="bussinessType" options={bussinessTypes} value={requirement.bussinessTypeId} optionLabel="bussinessType" optionValue="bussinessTypeId" labelText="Bussiness Type" onChange={handleBussinessType} errorMessage={formErrors.bussinessTypeId} required />
                    </div> */}
                    
                    
                    <div className="flex flex-column col-12 md:col-2 post-req-autocomplete company">
                        <AutoCompleteField dropdown name="company" labelText="Buyer Company" value={company} field="companyName" dropdownButton ClassName="styled-autocomplete-dropdown-button" searchMethod={companySearchMethod} suggestions={companySuggestions} onChange={handleCompanyChange} errorMessage={formErrors.companyId} forceSelection disabled={isCompanyDataLoading || buyerReqId} loading={isCompanyDataLoading} required />
                    </div>
                    <div className="flex flex-column col-12 md:col-2 company-branch">
                        <DropDownField name="companyBranch" options={companyBuyerBranches} value={requirement.branchId} optionLabel="branchName" optionValue="branchId" labelText="Branch" onChange={handleBranchChange} errorMessage={formErrors.branchId} {...(isBranchDataLoading ? { loading: true, disabled: true } : {})} required disabled={buyerReqId}/>
                    </div>
                    {
                        requirement.bussinessTypeId === 2 &&
                        <div className="flex flex-column col-12 md:col-2 lg:mb-0">
                            <DropDownField name="pmBranch" options={pmBranches} value={requirement.pmBranchId} optionLabel="branchName" optionValue="branchId" labelText="PM Branch" onChange={handlePMBranch} errorMessage={formErrors?.pmBranchId} required disabled={buyerReqId}/>
                        </div>
                    }
                    {
                        requirement.bussinessTypeId === 2 &&
                        <div className="flex flex-column col-12 md:col-2 lg:mb-0">
                            <DropDownField name="warehouse" options={updatedWarehouses} value={requirement.pmWarehouseId} optionLabel="warehouseName" optionValue="warehouseId" labelText="Warehouse" onChange={handlePMWarehouse} errorMessage={formErrors.pmWarehouseId} required disabled={buyerReqId}/>
                        </div>
                    }
                    <div className="flex flex-column col-12 md:col-2">
                        <DropDownField name="companyGSTIN" options={gstins} value={requirement.gstinId} optionLabel="gstinCode" optionValue="gstinId" labelText={PMCompanyConfig.GSTINLabel} onChange={handleGstinChange} errorMessage={formErrors.gstinId} {...(isGSTINSDataLoading ? { loading: true, disabled: true } : {})} required disabled={buyerReqId}/>
                    </div>
                    <div className="flex flex-column col-12 md:col-2">
                        <DropDownField name="companyUser" options={users} value={requirement.userId} optionLabel="fullName" optionValue="userId" labelText="User" onChange={handleUserChange} errorMessage={formErrors.userId} {...(isUsersDataLoading ? { loading: true, disabled: true } : {})} required disabled={buyerReqId}/>
                    </div>
                    {
                        requirement.bussinessTypeId === 1 &&
                        <div className="flex flex-column col-12 md:col-2 ware-house">
                            <DropDownField name="warehouse" options={updatedWarehouses} value={requirement.pmWarehouseId} optionLabel="warehouseName" optionValue="warehouseId" labelText="Warehouse" onChange={handlePMWarehouse} errorMessage={formErrors.pmWarehouseId} required disabled={buyerReqId}/>
                        </div>
                    }
                    {
                        requirement.bussinessTypeId === 1 &&
                        <div className="flex flex-column col-12 md:col-2 lg:mb-0">
                            <DropDownField name="pmBranch" options={pmBranches} value={requirement.pmBranchId} optionLabel="branchName" optionValue="branchId" labelText="PM Branch" onChange={handlePMBranch} errorMessage={formErrors?.pmBranchId} required disabled={buyerReqId}/>
                        </div>
                    }
                </div>
            </div>
            <div className='hr-line'></div>
            <div className='flex md:flex-row flex-column mt-3 justify-content-between'>
                <div className='flex md:flex-row flex-column justify-content-between pb-0'>
                    <div className="flex flex-column pl-0 pr-2 ml-1">
                        <div><span className='text-xs ml-2 md:ml-0'>Routed</span><span className="required-mark">*</span></div>
                        <div className="flex md:flex-column ml-2 mt-2">
                            <div className="flex ml-3 md:ml-0">
                                <RadioButton inputId="yes" value="Yes" onChange={handleRoutedChange} checked={requirement.isRouted === 'Yes'} disabled={requirement.bussinessTypeId === 2 || buyerReqId} />
                                <label htmlFor="yes" className="ml-1 text-xs ">Yes</label>
                            </div>
                            <div className="flex ml-4 md:ml-0">
                                <RadioButton inputId="no" value="No" onChange={handleRoutedChange} checked={requirement.isRouted === 'No'} disabled={requirement.bussinessTypeId === 2 || buyerReqId} />
                                <label htmlFor="no" className="ml-1 text-xs">No</label>
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-column md:px-3 px-2 ml-1 mt-2 md:ml-0 md:mt-0">
                        <div><span className='text-xs'>Tags</span><span className="required-mark">*</span></div>
                        <div className="flex flex-column ml-3 mt-1">
                        {reqTags.map(eachTag => {
                            return (
                                <div className="flex align-items-center" key={`reqTag-${eachTag.reqTagId}`}>
                                    <RadioButton className="mt-1" inputId={eachTag.reqTagId} name="reqTagId" value={eachTag.reqTagId} onChange={handleReqTagChange} checked={eachTag.reqTagId === requirement.reqTagId} disabled={requirement.reqTagId === 4 || buyerReqId || (requirement.bussinessTypeId === 1 && eachTag.reqTagId === 4)} />
                                    <label htmlFor={eachTag.reqTagId} className="ml-1 text-xs flex  align-items-center">{eachTag.reqTagName}</label>
                                </div>
                            )
                        })}
                        </div>
                    </div>
                    <div className="flex flex-column md:ml-3 md:mt-0 px-2 ml-1 mt-2">
                        <div><span className='font-medium mb-2 text-xs'>Requirement Source</span><span className="required-mark">*</span></div>
                        <div className='flex flex-column mt-2'>
                            <div className="flex md:ml-2 ml-3">
                                <RadioButton inputId="Mail" name="Mail" value="Mail" onChange={handleReqSource} checked={requirement.reqSource === 'Mail'} disabled={buyerReqId}/>
                                <label htmlFor="Mail" className="ml-1 text-xs">Mail</label>
                            </div>
                            <div className="flex md:ml-2 ml-3">
                                <RadioButton inputId="Whatsapp" name="Whatsapp" value="Whatsapp" onChange={handleReqSource} checked={requirement.reqSource === 'Whatsapp'} disabled={buyerReqId}/>
                                <label htmlFor="Whatsapp" className="ml-1 text-xs">Whatsapp</label>
                            </div>
                            <div className="flex md:ml-2 ml-3">
                                <RadioButton inputId="Other" name="Other" value="Other" onChange={handleReqSource} checked={requirement.reqSource === 'Other'} disabled={buyerReqId}/>
                                <label htmlFor="Other" className="ml-1 text-xs">Other</label>
                            </div>
                        </div>
                    </div>
                    {
                        company?.tags?.hasRCTaxExemption ? 
                        <div className="flex flex-column md:ml-3 md:mt-0 px-2 ml-1 mt-2">
                            <div><span className='font-medium mb-2 text-xs'>Tax Exemption</span><span className="required-mark">*</span></div>
                            <div className='flex flex-column mt-2'>
                                <div className="flex md:ml-2 ml-3">
                                    <RadioButton inputId="taxExempted" name="taxExempted" value="Yes" onChange={handleTaxExemption} checked={requirement.isTaxExempted === 'Yes'} disabled={buyerReqId}/>
                                    <label htmlFor="taxExempted" className="ml-1 text-xs">Yes</label>
                                </div>
                                <div className="flex md:ml-2 ml-3">
                                    <RadioButton inputId="taxNotExempted" name="taxNotExempted" value="No" onChange={handleTaxExemption} checked={requirement.isTaxExempted === 'No'} disabled={buyerReqId}/>
                                    <label htmlFor="taxNotExempted" className="ml-1 text-xs">No</label>
                                </div>
                            </div>
                        </div>
                        :
                        null
                    }
                    <div className="flex flex-column w-12rem mb-2 pl-0 pt-0 md:ml-4 mt-2 ml-3 md:mt-0">
                        <div className='mb-2'><label className='font-medium text-xs'>Requirement Date</label><span className="required-mark">*</span></div>
                        <CalendarField dateFormat='dd/mm/yy' value={requirement.requirementDate} minDate={lastMonthDate} maxDate={nextMonthDate} onChange={handleRequirementCreatedTime} showTime hourFormat="12" showIcon required disabled={buyerReqId}/>
                    </div>
                    <div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0">
                        <TextInputField name="PRNo" labelText='Client Req No.' value={requirement.clientReqNo} onChange={(e)=> handleClientReqNoChange(e)} errorMessage={formErrors.clientReqNo} />
                    </div>
                    <div className='flex flex-column pl-0 md:ml-4 ml-3'>
                        <label className="font-medium text-xs pb-2">Requirement Source Document<span className="required-mark">*</span></label>
                        <div>
                            {
                                requirement.reqSourceDoc ?
                                    // <div className='flex mt-3 ml-3'>
                                    //     <label key={requirement?.reqSourceDoc?.fileName}> <b className='text-xs'> {requirement?.reqSourceDoc?.fileName} &nbsp;&nbsp; </b></label>
                                    //     <Button className="decrement-btn-icon p-0 mb-3" icon="pi pi-minus-circle" text onClick={removeSourceDocument} size="small"/>
                                    // </div>
                                    <div className="">
                                        <FileViewAndRemove doc={{url: requirement.reqSourceDoc}} handleRemoveDoc={removeSourceDocument} docName="reqSourceDoc" showRemove />
                                    </div>
                                    :
                                    <div className='flex'>
                                        <FileUpload className="upload-btn w-7rem" mode="basic" name="reqSourceDoc" accept="image/*,application/pdf" customUpload uploadHandler={(files) => handleSourceDocUpload(files)} auto chooseLabel="Upload File" />

                                    </div>
                            }
                        </div>
                    </div>
                </div>
                <div className='flex flex-column mt-3 ml-3 md:ml-0'>
                    <div>
                        <Menu model={uploadOptions} popup menuRef={uploadMenu} id='upload-menu' />
                        <Button icon="pi pi-upload" className="h-2rem w-2rem p-2 custom-tool-tip-products-upload" aria-controls="upload-menu" onClick={(event) => uploadMenu.current.toggle(event)} disabled={fileUploadDisableCond} />
                        <input type="file" accept=".xlsx, .xls" className='hidden' onChange={handlProductsUploadFile} id='upload-xl-form' />
                        <Tooltip target=".custom-tool-tip-products-upload" content='File upload for products' position="top" autoHide={true} />
                    </div>
                </div>

            </div>

        </div>
    )
}

export default RequirementDetails